<h1 mat-dialog-title>{{data.title}}</h1>
<div mat-dialog-content>
  <div *ngIf="data.isHtmlString; else noHtmlMessage" [innerHTML]="data.msg"></div>
  <ng-template #noHtmlMessage></ng-template>
</div>
<div mat-dialog-actions align="end">
  <button mat-raised-button (click)="closeDialog()" *ngIf="data.showCloseButton">{{data.msgCloseButton ? data.msgCloseButton : 'Fechar'}}</button>
  <button mat-raised-button (click)="confirmDialog()" color="primary">{{data.msgConfirmButton ? data.msgConfirmButton : 'OK'}}</button>
</div>
